export const BASE_URL = 'https://pypirecom-api.azurewebsites.net';
